import { PUBLIC_HOST_RESERVED_PATHS } from "../public-dashboards/public-host-paths";
const APP_PATH_COLLISIONS = [
    "settings",
    "login",
    "logout",
    "invite",
    "reset-password",
    "forgot-password",
    "admin",
    "download",
    "redirect",
];
const PUBLIC_HOST_DNS_LABELS = [
    "www",
    "mail",
    "support",
    "help",
    "docs",
    "status",
    "staging",
    "dev",
    "test",
    "public",
];
export const RESERVED_WORKSPACE_URLS = [
    ...APP_PATH_COLLISIONS,
    ...PUBLIC_HOST_RESERVED_PATHS,
    ...PUBLIC_HOST_DNS_LABELS,
];
const RESERVED_SET = new Set(RESERVED_WORKSPACE_URLS);
export function isReservedWorkspaceUrl(url) {
    return RESERVED_SET.has(url.toLowerCase());
}
